module.exports = __webpack_public_path__ + "static/media/mitten.5143d850.svg";